const stepNumber = {
    one: 1,
    two: 2
};

export default stepNumber;
